import script from "./insertNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./insertNotice.vue?vue&type=script&setup=true&lang=ts"

import "./insertNotice.vue?vue&type=style&index=0&id=717e6644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717e6644"]])

export default __exports__